import { css } from "@emotion/react";
import Image from "next/image";
import { Body } from "@/components/Typography";
import { mq } from "@/constants/breakpoints";
import { gotham } from "@/utils/fonts";

interface ReviewBadgeHero2Props {
  imageSrc: string;
  color?: string;
  borderColor?: string;
  background?: string;
  starCount?: string | number;
  reviewCount?: string | number;
}

const ReviewBadgeHero2 = ({
  imageSrc,
  color,
  borderColor = "#ffffffa6",
  background,
  starCount,
  reviewCount,
}: ReviewBadgeHero2Props) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        white-space: nowrap;
        gap: 8px;
        padding: 4px 12px 4px 4px;
        background: ${background
          ? background
          : "linear-gradient(103.92deg, rgba(255, 255, 255, 0.1) -0.74%, rgba(190, 220, 255, 0.1) 99.87%)"};
        border-radius: 32px;
        border: 0.76px solid ${borderColor};
        ${mq["xs"]} {
          flex-grow: unset;
        }
        ${mq["sm"]} {
          flex-grow: 1;
        }
      `}
    >
      <Image
        src={imageSrc}
        width={24}
        height={24}
        alt="Review Stars Count badge"
      />

      <Body
        className={gotham.className}
        css={css`
          font-weight: 200 !important;
          font-size: 14px;
          line-height: 20px;
          color: ${color ? color : "#fff"};
        `}
      >
        {starCount && (
          <span
            css={css`
              font-weight: 700;
              font-size: 16px;
            `}
          >
            {starCount}{" "}
          </span>
        )}
        stars{" "}
        {reviewCount && (
          <span
            css={css`
              font-weight: 700;
              font-size: 16px;
            `}
          >
            {reviewCount}+{" "}
          </span>
        )}
        reviews
      </Body>
    </div>
  );
};

export default ReviewBadgeHero2;
